// @flow
import * as React from 'react'
import type {
  PropsSchema,
  EasyAction,
  EventSourceMap,
  JsEnv
} from '../../../type'
import computeData from '../../hoc/computeData'
import styles from './CircleZhuanPan.scss'
import $ from 'jquery'

type Props = {
  customProps: {
    $comp: {
      circleConfig?: {
        backgroundImage?: {
          url: string
        },
        defaultImage?: {
          url: string
        },
        btnImage?: {
          url: string
        }
      }
    }
  },
  jsEnv: JsEnv,
  id: string,
  children: React.ChildrenArray<React.Node>,
  events: EventSourceMap,
  visible: boolean,
  callActions: (actionName: string, dynamicData: any) => {},
  backgroundImage: ?{
    url: string
  },
  defaultImage: ?{
    url: string
  },
  btnImage: ?{
    url: string
  }
};

type State = {
  clickCount: number
};

@computeData({ includeData: true })
export default class extends React.PureComponent<Props, State> {
  static schema: PropsSchema = [
    {
      type: 'image',
      key: 'backgroundImage',
      title: '背景图片'
    },
    {
      type: 'image',
      key: 'defaultImage',
      title: '转盘原始图片'
    },
    {
      type: 'image',
      key: 'btnImage',
      title: '转盘指针图片'
    },
    'separator',
    {
      type: 'event',
      event: 'stop',
      title: '停止'
    }
  ];
  static actions: EasyAction[] = [
    {
      title: '开始',
      name: 'begin'
    }
  ];
  drawing: boolean;
  constructor (props: Props) {
    super(props)
    this.state = {
      clickCount: 0
    }
  }
  componentWillUnmount () {}

  actionBegin = (data: void, dynamicData: { targetNum: number }) => {
    let { clickCount } = this.state
    if (this.drawing) {
      return
    }
    this.drawing = true
    setTimeout(() => {
      this.drawing = false
      this.props.callActions('stop')
    }, 5000)
    clickCount++
    this.setState({
      clickCount
    })
    let gargetRotate = clickCount * 3600 - 45 * (dynamicData.targetNum - 1)
    $(this.refs.award).css({
      transform: `rotate(${gargetRotate}deg)`,
      transition: '5s transform ease-in-out'
    })
  };

  render () {
    let {
      customProps = {},
      jsEnv,
      children,
      visible,
      backgroundImage,
      defaultImage,
      btnImage
    } = this.props
    let circleConfig =
      customProps.$comp && customProps.$comp.circleConfig
        ? customProps.$comp.circleConfig
        : {}
    backgroundImage = backgroundImage || circleConfig.backgroundImage || {}
    defaultImage = defaultImage || circleConfig.defaultImage || {}
    btnImage = btnImage || circleConfig.btnImage || {}
    let backgroundImageUrl = jsEnv.getString(backgroundImage.url || '')
    let defaultImageUrl = jsEnv.getString(defaultImage.url || '')
    let btnImageUrl = jsEnv.getString(btnImage.url || '')
    if (!visible) {
      return null
    }
    return (
      <div
        className={`${styles.this}`}
        style={{
          backgroundImage: `url(${backgroundImageUrl})`
        }}
      >
        <div style={{ position: 'relative' }}>
          <img
            ref='award'
            src={defaultImageUrl}
            className={`full ${styles.award}`}
          />
          <div
            className={`${styles.arrow}`}
            style={{
              backgroundImage: "url('" + btnImageUrl + "')",
              backgroundSize: '1.6rem 1.6rem'
            }}
          />
        </div>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/ui/Draw/CircleZhuanPan.js